import { useQuery } from "@apollo/client";
import { useMemo } from "react";

import { EventApiResponse } from "../../../common/types/events/api";
import { buildEventDetailsQueryVariables } from "../../../common/utils/buildEventDetailsQueryVariables";
import { handleApolloError } from "../../../common/utils/handleApolloError";
import { GET_EVENT_DETAILS } from "../../../rest/queries";
import { mapEventEntityToViewModel } from "../adapters/eventAdapter";
import { EventViewModel } from "../models/eventViewModel";

export const useGetEventDetailsById = (pk: string, sk: string) => {
  const skip = !pk || !sk;

  const variables = buildEventDetailsQueryVariables({
    pk,
    sk,
  });
  const { data, loading, error } = useQuery<{
    eventDetails: EventApiResponse;
  }>(GET_EVENT_DETAILS, {
    variables,
    skip,
    fetchPolicy: "no-cache",
    onError: handleApolloError,
  });

  const event = useMemo<EventViewModel | null>(
    () =>
      data?.eventDetails?.data?.event
        ? mapEventEntityToViewModel(data.eventDetails.data.event)
        : null,
    [data]
  );

  return {
    event,
    loading,
    error,
  } as const;
};
